const MaturityLevelAnalyzer = ({ companyName = "Incorp.AI" }) => {

    return (
        <iframe src={`${process.env.REACT_APP_SURVEY_FORM}${companyName}`}
            className="w-100"
            width="800"
            height="600"
            title="AI Navigator"
        >
            Loading…
        </iframe>
    );
};

export default MaturityLevelAnalyzer;
